import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & > :last-child {
    margin-top: auto;
    margin-bottom: 0;
    width: 100%;
    display: flex;
    .ant-pagination-total-text {
      margin-right: auto;
      margin-left: 0;
      & > div {
        height: 100%;
        padding-top: 5px;
      }
    }
  }

  .ant-table-pagination {
  }
`;
